import React, { useState, useEffect, useRef } from "react";
import DiscussionParticipant from "./DiscussionParticipant";
import MessageTypeWritter from "./MessageTypeWritter";
import Moments from "./Moments";
import {
  getMeetingMessages,
  getMeetingParticipants,
  createMessage,
  updateMessage,
  deleteMessage,
  getDestinationMeetings,
} from "./api";
import { FaThumbtack, FaTimes } from "react-icons/fa";
import { API_BASE_URL, Assets_URL } from "../../Apicongfig";
import axios from "axios";
import StepChart from "../Meeting/CreateNewMeeting/StepChart";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

function DiscussionChat({ meetingId, meetingsData, onMeetingsUpdate }) {
  const [messages, setMessages] = useState([]);
  const [selectedMoment, setSelectedMoment] = useState(null);
  const [loading, setLoading] = useState({ messages: true });
  const [editingMessage, setEditingMessage] = useState(null);
  const [showActionModal, setShowActionModal] = useState(false);
  const [selectedMessageForAction, setSelectedMessageForAction] =
    useState(null);
  const [isDrop, setIsDrop] = useState(false);
  const [id, setId] = useState(null);
  const [actionModalId, setActionModalId] = useState(null);
  const [t] = useTranslation("global");
  const editorRef = useRef(null);
  const [attachments, setAttachments] = useState([]);
  const navigate = useNavigate();
  const messagesEndRef = useRef(null);
  const messageContainerRef = useRef(null);
  const scrollToBottom = () => {
    if (messageContainerRef.current) {
      messageContainerRef.current.scrollTop = messageContainerRef.current.scrollHeight;
    }
  };
  useEffect(() => {
    if (meetingsData?.length > 0 && !selectedMoment) {
      setSelectedMoment(meetingsData[0]);
    }
  }, [meetingsData]);

  useEffect(() => {
    if (!meetingId || !selectedMoment) return;

    const fetchMessages = async () => {
      try {
        setLoading((prev) => ({ ...prev, messages: true }));
        const messagesData = await getMeetingMessages(
          meetingId,
          selectedMoment.id
        );
        const sortedMessages = [...(messagesData?.data || [])].sort(
          (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );
        setMessages(sortedMessages);
        
        setEditingMessage(null);
           // Scroll to bottom after a slight delay to ensure rendering
      setTimeout(scrollToBottom, 100);
      } catch (error) {
        console.error("Error fetching messages:", error);
      } finally {
        setLoading((prev) => ({ ...prev, messages: false }));
      }
    };

    fetchMessages();
  }, [meetingId, selectedMoment]);


  const handleSendMessage = async (messageContent) => {
    try {
      const formData = new FormData();
      const userId = parseInt(sessionStorage.getItem("user_id")) || null;
  
      if (editingMessage) {
        // Edit existing message
        formData.append("_method", "PUT");
        formData.append("message", messageContent.message);
  
        // Call API directly for update
        const response = await fetch(`${API_BASE_URL}/meeting-messages/${editingMessage.id}`, {
          method: 'POST', // Using POST with _method=PUT for Laravel
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
          body: formData
        });
  
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Failed to update message');
        }
  
        const responseData = await response.json();
  
        if (responseData.success) {
          setMessages(prev => prev.map(msg => 
            msg.id === editingMessage.id ? responseData.data : msg
          ));
          setEditingMessage(null);
          setAttachments([]);
        }
  
      } else {
        // Create new message
        formData.append("meeting_id", selectedMoment?.id);
        if(userId){
          formData.append("user_id", userId || null);
        }
        formData.append("message", messageContent.message);
  
        // Add attachments
        attachments.forEach((file, index) => {
          formData.append(`attachments[${index}]`, file);
        });
  
        // Call API directly for creation
        const response = await fetch(`${API_BASE_URL}/meeting-messages`, {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`,
          },
          body: formData
        });
  
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Failed to send message');
        }
  
        const responseData = await response.json();
  
        if (responseData.success) {
          // Optimistic update
          setMessages(prev => [...prev, responseData.data]);
          setAttachments([]);
          
          // Scroll to bottom after state update
          setTimeout(() => {
            const messageContainer = document.querySelector(".message-container");
            if (messageContainer) {
              messageContainer.scrollTop = messageContainer.scrollHeight;
            }
          }, 0); // Reduced timeout for better UX
        }
      }
    } catch (error) {
      console.error("Error sending message:", error);
      // User feedback (example using toast)
      // toast.error(error.message || "Failed to send message");
      
      // Optionally: Revert optimistic update here if needed
    }
  };

   const handleFileUpload = (e) => {
    const files = Array.from(e.target.files);
    setAttachments(prev => [...prev, ...files]);
  };

  const removeAttachment = (index) => {
    setAttachments(prev => prev.filter((_, i) => i !== index));
  };


  const handleEditMessage = (message) => {
    setEditingMessage(message);
    if (editorRef.current) {
      editorRef.current.setContent(message.message);
    }
  };

  const handleDeleteMessage = async (messageId) => {
    if (window.confirm("Are you sure you want to delete this message?")) {
      try {
        const response = await deleteMessage(messageId);
        if (response.success) {
          setMessages((prev) => prev.filter((msg) => msg.id !== messageId));
        }
      } catch (error) {
        console.error("Error deleting message:", error);
      }
    }
  };

//  const handlePinMessage = async (messageId, isPinned) => {
//     try {
//         const formData = new FormData();
//         formData.append("is_pinned", !isPinned);
//         formData.append("_method", "put");

//         const response = await updateMessage(messageId, formData);

//         if (response.success) {
//             setMessages((prev) =>
//                 prev.map((msg) => (msg.id === messageId ? response.data : msg))
//             );
//         }
//     } catch (error) {
//         console.error("Error pinning message:", error);
//         // Optional: Add user feedback
//         // alert("Failed to update pin status: " + (error.response?.data?.message || error.message));
//     }
// };

const handlePinMessage = async (messageId, isPinned) => {
  try {
      // Create FormData payload
      const formData = new FormData();
      formData.append("is_pinned", !isPinned);
      formData.append("_method", "PUT");  // For Laravel-style API method override

      // Call API directly with fetch
      const response = await fetch(`${API_BASE_URL}/meeting-messages/${messageId}`, {
          method: 'POST',  // Using POST with _method=PUT for Laravel compatibility
          headers: {
              'Authorization': `Bearer ${localStorage.getItem('token')}`,
              // Don't set Content-Type - let browser set it with boundary
          },
          body: formData
      });

      // Handle non-successful responses
      if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Failed to update pin status');
      }

      const responseData = await response.json();

      // Update state only if API call was successful
      if (responseData.success) {
          setMessages(prevMessages => 
              prevMessages.map(msg => 
                  msg.id === messageId ? { ...msg, is_pinned: !isPinned } : msg
              )
          );
          
          // Optional: Show success feedback
          // toast.success("Message pin status updated");
      }

  } catch (error) {
      console.error("Error pinning message:", error);
      
      // User-friendly error handling
      // toast.error(error.message || "Failed to update pin status");
      
      // Optionally revert the UI change
      // setMessages(prevMessages => 
      //    prevMessages.map(msg => 
      //        msg.id === messageId ? { ...msg, is_pinned: isPinned } : msg  // Revert to previous state
      //    )
      // );
  }
};
  const handleMomentSelect = async (moment) => {
    setSelectedMoment(moment);
    setEditingMessage(null);

    try {
      const readResponse = await axios.post(
        `${API_BASE_URL}/meeting/${moment?.id}/message-read`,
        null,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (readResponse.status === 200 || readResponse.status === 201) {
        const meetingsResponse = await getDestinationMeetings(
          moment.destination_id
        );

        if (meetingsResponse?.data) {
          onMeetingsUpdate(meetingsResponse.data);
        }
      }
    } catch (error) {
      console.error("Error in moment selection:", error);
    }
  };

  const cancelEdit = () => {
    setEditingMessage(null);
    if (editorRef.current) {
      editorRef.current.setContent("");
    }
  };

  const handleShowAction = (message) => {
    console.log("message", message);
    if(message?.message_type === "notification"){
      navigate(`${message?.redirect_url}`)
    }else{
      setSelectedMessageForAction(message);
      setActionModalId(message);
      setShowActionModal(true);
    }
  };

  const handleHideAction = (shouldRefresh) => {
    setShowActionModal(false);
    if (shouldRefresh && meetingId && selectedMoment) {
      const fetchMessages = async () => {
        try {
          setLoading((prev) => ({ ...prev, messages: true }));
          const messagesData = await getMeetingMessages(
            meetingId,
            selectedMoment.id
          );
          const sortedMessages = [...(messagesData?.data || [])].sort(
            (a, b) => new Date(a.created_at) - new Date(b.created_at)
          );
          setMessages(sortedMessages);
        } catch (error) {
          console.error("Error fetching messages:", error);
        } finally {
          setLoading((prev) => ({ ...prev, messages: false }));
        }
      };
      fetchMessages();
    }
  };

  const MessageItem = ({
    message,
    onEdit,
    onDelete,
    onPin,
    onShowAction,
    isEditing,
    currentUserId,
  }) => {
    const isCurrentUser = message.user_id === currentUserId;

    const formatDateForDisplay = (isoString) => {
      return new Date(isoString).toLocaleString("en-US", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    };




      const renderAttachment = (attachment) => {
      const fileType = attachment?.type?.split('/')[0];
      const fileUrl = `${Assets_URL}/${attachment?.path}`;
      
      switch(fileType) {
        case 'image':
          return (
            <div className="attachment-item mb-2">
              <img 
                src={fileUrl} 
                alt="Attachment" 
                className="img-fluid rounded"
                style={{ maxHeight: '200px' }}
              />
            </div>
          );
        case 'application':
          return (
            <div className="attachment-item mb-2">
              <a 
                href={fileUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="d-flex align-items-center gap-2 text-decoration-none"
              >
                <div className="bg-light p-2 rounded">
                  <i className="bi bi-file-earmark-text fs-4"></i>
                </div>
                <div>
                  <div className="text-primary">{attachment.name}</div>
                  <small className="text-muted">{(attachment.size / 1024).toFixed(2)} KB</small>
                </div>
              </a>
            </div>
          );
        default:
          return (
            <div className="attachment-item mb-2">
              <a 
                href={fileUrl} 
                target="_blank" 
                rel="noopener noreferrer"
                className="d-flex align-items-center gap-2 text-decoration-none"
              >
                <div className="bg-light p-2 rounded">
                  <i className="bi bi-file-earmark fs-4"></i>
                </div>
                <div>
                  <div className="text-primary">{attachment.name}</div>
                  <small className="text-muted">{(attachment.size / 1024).toFixed(2)} KB</small>
                </div>
              </a>
            </div>
          );
      }
    };
    return (
      <div
        className={`message mb-4 ${message?.is_pinned ? "pinned-message" : ""}`}
      >
        {message?.is_pinned && (
          <div className="pinned-badge text-muted mb-1">
            <FaThumbtack className="me-1" /> {t("Pinned")}
          </div>
        )}
        <div className="d-flex gap-3">
          <div className="flex-shrink-0">
            <img
              src={
                message?.user?.image
                  ? message.user?.image?.startsWith("http")
                    ? message?.user?.image
                    : Assets_URL + "/" + message?.user?.image
                  : message?.user_image
              }
              width={48}
              height={48}
              alt="User"
              className="rounded-circle object-fit-cover"
              style={{ objectPosition: "top" }}
            />
          </div>
          <div className="flex-grow-1">
            <div className="d-flex align-items-center gap-2 mb-1">
              <strong className="text-primary">
                {message?.user?.full_name || message?.user_name}
              </strong>
              <small className="text-muted">
                {formatDateForDisplay(message?.created_at)}
              </small>
            </div>
            <div
              className={`paragraph-parent message-content bg-light p-3 rounded-3 ${
                isEditing ? "editing" : ""
              }`}
              style={{
                overflow: "hidden",
              }}
            >
              <span className="paragraph paragraph-images">
                <div
                  dangerouslySetInnerHTML={{ __html: message.message }}
                  style={{
                    maxWidth: "100%",
                    wordBreak: "break-word",
                    "& img": {
                      maxWidth: "100%",
                      height: "auto",
                      display: "block",
                      margin: "5px 0",
                    },
                  }}
                />
              </span>

               {/* Display attachments */}
              {message.attachments && message.attachments.length > 0 && (
                <div className="attachments-container mt-3">
                  {message.attachments.map((attachment, index) => (
                    <div key={index}>
                      {renderAttachment(attachment)}
                    </div>
                  ))}
                </div>
              )}
            </div>
            <div className="d-flex gap-2 mt-2">
              {isCurrentUser && (
                <>
                  <button
                    className="btn btn-sm btn-link p-0 text-muted"
                    onClick={() => onEdit(message)}
                    disabled={isEditing}
                  >
                    {t("Edit")}
                  </button>
                  <span className="text-muted">•</span>
                  <button
                    className="btn btn-sm btn-link p-0 text-muted"
                    onClick={() => onDelete(message.id)}
                    disabled={isEditing}
                  >
                    {t("Delete")}
                  </button>
                  <span className="text-muted">•</span>
                </>
              )}
              <button
                className="btn btn-sm btn-link p-0 text-muted"
                onClick={() => onPin(message.id, message.is_pinned)}
              >
                {message.is_pinned ? t("Unpin") : t("Pin")}
              </button>
              <span className="text-muted">•</span>
             {message?.message_type === "notification" && message?.redirect_url === null ? null : <button
                className="btn btn-sm btn-link p-0 text-muted"
                onClick={() => onShowAction(message)}
              >
                {message?.message_type === "notification" ? t("View Action") :t("Create Action")}
              </button>}
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className="mt-5">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="row justify-content-between">
              <div className="col-md-3 mt-3 px-3 px-md-0">
                <Moments
                  meetingsData={meetingsData}
                  onMomentSelect={handleMomentSelect}
                  selectedMoment={selectedMoment}
                />
              </div>

              <div className="col-md-6 mt-3 px-3 px-md-2">
                <div className="card rounded-0 h-100">
                  <div
                    className="card-body d-flex flex-column"
                    style={{ minHeight: "70vh" }}
                  >
                    {selectedMoment && (
                      <div className="moment-header mb-3 border-bottom pb-3">
                        <div className="d-flex justify-content-between align-items-center">
                          <h5 className="mb-1">{selectedMoment.title}</h5>
                          <Link
                            to={
                              selectedMoment?.status === "closed" ||
                              selectedMoment?.status === "abort"
                                ? `/present/invite/${selectedMoment?.id}`
                                : `/invite/${selectedMoment?.id}`
                            } // Replace with your actual route path
                            className="btn btn-sm btn-outline-primary"
                            style={{
                              fontSize: "0.8rem",
                              padding: "0.25rem 0.5rem",
                            }}
                          >
                            {t("View")}{" "}
                            {/* You can change the text as needed */}
                          </Link>
                        </div>
                      </div>
                    )}

                    <div
                      className="message-container flex-grow-1 mb-3"
                      ref={messageContainerRef}
                      style={{
                        overflowY: "auto",
                        maxHeight: "calc(70vh - 200px)",
                        scrollBehavior: "smooth",
                      }}
                    >
                      {loading.messages ? (
                        <div className="d-flex justify-content-center align-items-center h-100">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      ) : messages.length > 0 ? (
                        <>
                          {messages
                            .filter((msg) => msg.is_pinned)
                            .map((message) => (
                              <MessageItem
                                key={message.id}
                                message={message}
                                onEdit={handleEditMessage}
                                onDelete={handleDeleteMessage}
                                onPin={handlePinMessage}
                                onShowAction={handleShowAction}
                                isEditing={editingMessage?.id === message.id}
                                currentUserId={parseInt(
                                  sessionStorage.getItem("user_id")
                                )}
                              />
                            ))}
                          {messages
                            .filter((msg) => !msg.is_pinned)
                            .map((message) => (
                              <MessageItem
                                key={message.id}
                                message={message}
                                onEdit={handleEditMessage}
                                onDelete={handleDeleteMessage}
                                onPin={handlePinMessage}
                                onShowAction={handleShowAction}
                                isEditing={editingMessage?.id === message.id}
                                currentUserId={parseInt(
                                  sessionStorage.getItem("user_id")
                                )}
                              />
                            ))}
                        </>
                      ) : (
                        <div className="d-flex justify-content-center align-items-center h-100">
                          <div className="text-center text-muted py-4">
                            <i className="bi bi-chat-square-text fs-1"></i>
                            <p className="mt-2">
                              {selectedMoment
                                ? t("No messages yet for this moment")
                                : t("Select a moment to view messages")}
                            </p>
                          </div>
                        </div>
                      )}
                    </div>

                   
                    {selectedMoment && (
                      <div className="mt-auto">
                        {/* Display attachments preview before sending
                        {attachments.length > 0 && (
                          <div className="attachments-preview mb-3 p-2 bg-light rounded">
                            <div className="d-flex flex-wrap gap-2">
                              {attachments.map((file, index) => (
                                <div key={index} className="position-relative">
                                  {file.type.startsWith('image/') ? (
                                    <img
                                      src={URL.createObjectURL(file)}
                                      alt={file.name}
                                      className="img-thumbnail"
                                      style={{ height: '60px', width: 'auto' }}
                                    />
                                  ) : (
                                    <div className="d-flex align-items-center gap-2 bg-white p-2 rounded border">
                                      <i className="bi bi-file-earmark-text fs-4"></i>
                                      <div>
                                        <div className="small text-truncate" style={{ maxWidth: '150px' }}>
                                          {file.name}
                                        </div>
                                        <small className="text-muted">
                                          {(file.size / 1024).toFixed(2)} KB
                                        </small>
                                      </div>
                                    </div>
                                  )}
                                  <button
                                    className="btn btn-sm btn-danger position-absolute top-0 end-0 translate-middle"
                                    style={{ padding: '0.1rem 0.25rem' }}
                                    onClick={() => removeAttachment(index)}
                                  >
                                    <FaTimes size={10} />
                                  </button>
                                </div>
                              ))}
                            </div>
                          </div>
                        )} */}
                        
                        <MessageTypeWritter
                          onSendMessage={handleSendMessage}
                          disabled={loading.messages}
                          editorRef={editorRef}
                          isEditing={!!editingMessage}
                          onCancelEdit={cancelEdit}
                          participants={selectedMoment?.user_with_participants}
                          meeting={selectedMoment}
                          onFileUpload={handleFileUpload}
                          attachments={attachments}
                          onRemoveAttachment={removeAttachment}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-md-3 mt-3 px-3 px-md-2">
                <DiscussionParticipant
                  meetingId={meetingId}
                  selectedMoment={selectedMoment}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {showActionModal && (
        <div className="new-meeting-modal">
          <StepChart
            meetingId={selectedMoment?.id}
            id={id}
            show={showActionModal}
            setId={setId}
            closeModal={handleHideAction}
            meeting={selectedMoment}
            isDrop={isDrop}
            setIsDrop={setIsDrop}
            editorContent={actionModalId}
            openedFrom="discussion"
          />
        </div>
      )}
    </div>
  );
}

export default DiscussionChat;
